<template>
  <v-container>
    <navigation></navigation>
    <v-breadcrumbs :items="crumbs" large>
    </v-breadcrumbs>
    <div class="grey lighten-5">
      <v-row no-gutters>
        <v-col cols="12" sm="5">
          <v-card class="pa-2"  height="130" outlined tile>
            <v-subheader>Patient details</v-subheader>
            <div :class="$style.formRow">
              <v-flex xs4 sm4 md3>
                Name:
              </v-flex>
              <v-flex xs9 sm8 md8>
                {{patient.name}}
              </v-flex>
            </div>
            <div :class="$style.formRow">
              <v-flex xs4 sm4 md3>
                D.O.B:
              </v-flex>
              <v-flex xs9 sm8 md8>
                {{patient.birthdate}}
              </v-flex>
            </div>
            <div :class="$style.formRow">
              <v-flex xs4 sm4 md3>
                SVHA UR::
              </v-flex>
              <v-flex xs9 sm8 md8>
                {{patient.id}}
              </v-flex>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="3">
          <v-card class="pa-2" height="130" outlined tile>
            <v-subheader></v-subheader>
            <div :class="$style.formRow">
              <h3>Survey Report</h3>
            </div>
            <div :class="$style.formRow">
              <h4>W.O.M.A.C</h4>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card class="pa-2"  height="130" outlined tile>
            <v-subheader>OAHKS Clinic</v-subheader>
            <p>Completed: 25-May-2020</p>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-divider></v-divider>
    <v-subheader>Survey question responses</v-subheader>
    <v-divider></v-divider>
    <v-subheader>Survey scoring and assessment</v-subheader>
    <v-data-iterator
      :items="items"
      :items-per-page.sync="itemsPerPage"
      hide-default-footer
    >

      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.name"
            cols="12"
            sm="6"
            md="4"
            lg="3"
          >
            <v-card>
              <v-card-title class="subheading font-weight-bold">Pain</v-card-title>

              <v-divider></v-divider>

              <v-list dense>
                <v-list-item>
                  <v-list-item-content>Pain:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.calories }}</v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>Stiffness:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.fat }}</v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>Physical Function:</v-list-item-content>
                  <v-list-item-content class="align-end">{{ item.carbs }}</v-list-item-content>
                </v-list-item>

              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <template v-slot:footer>
        <v-toolbar
          class="mt-2"
          color="indigo"
          dark
          flat
        >
        </v-toolbar>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
import Navigation from '@/components/Navigation.vue'

export default {
  data () {
    return {
      crumbs: [
        { text: 'Patients', disabled: false, href: '/' },
        { text: 'Encounter-10001', disabled: false, href: `#` },
        { text: 'Survey-VR12', disabled: true, href: `#` }
      ],
      items: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          sodium: 87,
          calcium: '14%',
          iron: '1%',
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          sodium: 129,
          calcium: '8%',
          iron: '1%',
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          sodium: 337,
          calcium: '6%',
          iron: '7%',
        },
        {
          name: 'Cupcake',
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          sodium: 413,
          calcium: '3%',
          iron: '8%',
        },
      ],
      patient: { name: 'Joe Bloggs', birthdate: '10-Jan-1968', id: '34235345'},
    }
  },
  components: {
    Navigation
  },
}
</script>

<style module>
.formRow {
  display: flex;
  width: 100%;
}

</style>